<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-11-03 12:44:40
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-03 16:19:45
 * @Description: 
-->
<template>
  <div class="newAgency">
    <el-row class="newAgency-title">
      <el-col :span="24">
        <!-- <p class="text">{{dte}}年第{{quarter}}季度报告</p> -->
        <p class="text">{{ reportName }}</p>
      </el-col>
      <el-row class="steps-row">
        <el-steps :active="activeStep" align-center>
          <el-step
            :title="item"
            description
            v-for="(item, index) of stepArr"
            :key="item"
            @click.native="toStep(index)"
          ></el-step>
        </el-steps>
      </el-row>
    </el-row>

    <step-com :comArr="comArr" :myactiveStep="activeStep" @active="activeChange"></step-com>
  </div>
</template>

<script>
import StepCom from 'common/components/steps/stepItem'
const path = `QuaReport/components/mgrcom`

export default {
  components: {
    StepCom
  },

  data() {
    return {
      activeStep: 0,
      dte: '2022',
      quarter: '一',
      reportName: this.$route.query.reportName,
      stepArr: ['信息表上传', '完成提交'],
      comArr: [`${path}/step1`, `${path}/step2`]
    }
  },
  methods: {
    activeChange(ev) {
      this.activeStep = ev
    }
  }
}
</script>

<style>
.steps-row {
  height: 100%;
  padding-bottom: 15px;
  display: flex;
  /* overflow: auto; */
  flex-direction: column;
  justify-content: flex-end;
}
</style>
<style lang="scss" scoped>
.newAgency {
  height: 100%;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  &-title {
    height: 220px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 12px 0px #cccccc80;
    padding: 20px;
    display: flex;
    flex: 0 0 auto;
    // overflow: auto;
    flex-direction: column;
    .steps-row {
      height: 100%;
      padding-bottom: 15px;
      display: flex;
      // overflow: auto;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
::v-deep .userInfo {
  &::before {
    display: none;
  }
}
</style>
